import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private httpLoading$ = new ReplaySubject<boolean>(1);
    private appLoading$ = new ReplaySubject<boolean>(1);
    
    constructor() {
        // Default to not loading
        this.appLoading$.next(false);
    }

    httpProgress(): Observable<boolean> {
        return this.httpLoading$.asObservable();
    }

    setHttpProgressStatus(inprogess: boolean) {
        this.httpLoading$.next(inprogess);
    }
    
    isAppLoading(): Observable<boolean> {
        return this.appLoading$.asObservable();
    }
    
    setAppLoading(isLoading: boolean) {
        this.appLoading$.next(isLoading);
    }
}
